<template>
    <div class="px-2">
        <!-- add dialog -->
        <v-dialog v-model="dialog" width="400">
            <v-form ref="addForm" @submit.prevent="addDocument">
                <v-card>
                    <v-card-title class="headline">
                        <v-row no-gutters class="justify-space-between">
                            <v-col cols="auto" class="headline d-flex align-center">
                                {{ $t('TransferDocument.create-document') }}
                            </v-col>
                            <v-col cols="auto" class="d-flex align-center">
                                <v-checkbox
                                    v-model="isMultipleWarehouses"
                                    class="my-0"
                                    dense
                                    hide-details
                                    :label="$t('TransferDocument.multiple-warehouses')"
                                />
                            </v-col>
                        </v-row>
                        <div>

                        </div>
                    </v-card-title>
                    <v-card-text class="pb-0">
                        <v-row no-gutters>
                            <v-col cols="12" class="py-2">
                                <bee-date-picker
                                    v-model="createBondForm.date"
                                    context="materials_journal"
                                    :action-name="actions.CREATE"
                                    :label="$t('AccountingJournalPage.bond-date')"
                                    :hide-details="true"
                                    :rules="[rules.date]"
                                />
                            </v-col>
                            <v-expand-transition>
                                <v-col v-if="!isMultipleWarehouses" cols="12">
                                    <v-row no-gutters>
                                        <v-col cols="12" class="d-flex align-center py-3">
                                            <v-autocomplete
                                                v-model="createBondForm.source_warehouse_id"
                                                :items="createBondForm.target_warehouse_id ? warehouses.filter(c => c.id !== createBondForm.target_warehouse_id) : warehouses" 
                                                item-text="name"
                                                outlined
                                                :label="$t('headers.source-warehouse')"
                                                hide-details
                                                :rules="[v => !!v]"
                                                dense
                                                item-value="id"
                                            />
                                        </v-col>
                                        <v-col cols="12" class="d-flex align-center py-2">
                                            <v-autocomplete
                                                v-model="createBondForm.target_warehouse_id "
                                                :items="createBondForm.source_warehouse_id ? warehouses.filter(c => c.id !== createBondForm.source_warehouse_id) : warehouses" 
                                                item-text="name"
                                                outlined
                                                :label="$t('headers.target-warehouse')"
                                                :rules="[v => !!v]"
                                                hide-details
                                                dense
                                                item-value="id"
                                            />
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-expand-transition>
                        </v-row>
                    </v-card-text>
                    <v-card-actions class="ms-3">
                        <v-btn color="greenDarken1" text type="submit" :loading="loading" >
                            {{$t('MaterialsJournalPage.create')}}
                        </v-btn>
                        <v-btn color="redDarken1" text @click="dialog = false" >
                            {{$t('MaterialsJournalPage.cancel')}}
                        </v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>

        <!-- delete dialog -->
		<bee-dialog
			v-model="deleteDialog"
			max-width="350"
			:persistent="true"
			:title="$t('TransferDocument.delete-document')"
			:message="$t('TransferDocument.are-you-sure-you-want-to-delete-the-document')"
            :loading-confirm="loading"
			@click:confirm="confirmDeleteDocument"
			@click:close="entryId = null; deleteDialog = false;"
		></bee-dialog>
        <!-- filter and buttons -->
        <v-row class="ma-0 pt-0">
            <v-col md="auto" cols="12" align-self="center" class="pb-1">
                <slot name="breadcrumbs" :item="true"></slot>
            </v-col>
    
            <!-- no -->
            <v-col cols="12" sm="6" md="auto" class="d-flex align-center pb-1">
                <bee-bond-up-down
                    v-model="boundNo"
                    :label="$t('CashJournalPage.bond-number')"
                    :items="boundNoList"
                    class="medium-placeholder"
                    :disabled="loading || !boundNoList?.length"
                    @keydown-enter-prevent="fetchJournalByNo()"
                    @programmatically-changed="fetchJournalByNo()"
                >

                </bee-bond-up-down>
				<!-- <v-btn icon @click="prevJournal()">
					<v-icon>{{ $i18n.locale === 'en' ? 'mdi-menu-left' : 'mdi-menu-right'}}</v-icon>
				</v-btn>
                <v-text-field
					v-model.number="boundNo"
					label="رقم السند"
					type=number
					dense
					hide-details
					:disabled="loading"
				/>
				<v-btn icon @click="nextJournal()">
					<v-icon>{{$i18n.locale === 'en' ? 'mdi-menu-right' : 'mdi-menu-left'}}</v-icon>
				</v-btn> -->
			</v-col>
            <!--  -->
            <v-col cols="auto" align-self="center" class="pb-1">
                <v-btn @click="dialog = true" :disabled="loading" color="addingColor white--text">
                    <v-icon> mdi-plus </v-icon>
                    {{ $t('add') }}
                </v-btn>

                <v-btn
                	v-if="!isPosted && $route.query.id"
                	color="deletingColor white--text"
                	class="mx-2 py-0"
                    :disabled="loading" 
                	@click="deleteDialog = true"
                >
                    <v-icon> mdi-delete </v-icon>
                    {{ $t('buttons.delete') }}
                </v-btn>
            </v-col>
            <v-spacer />
            <v-col cols="auto" class="d-flex align-center pb-1">
                <v-tooltip right>
                    <template v-slot:activator="{on, attrs}">
                        <div
                            v-on="on"
                            v-bind="attrs"
                        >
                            <v-btn
                                icon
                                :disabled="loading || !$route.query.id" 
                                :loading="materialsLoading "
                                @click="fetchMaterials()"
                            >
                                <v-icon  color="primary" size="18">
                                    fa-sync
                                </v-icon>
                            </v-btn>
                        </div>
                    </template>
                    {{$t('update-materials')}}
                </v-tooltip>
            </v-col>
            <v-col v-if="$route.query.id" cols="auto" class="d-flex align-center pb-1">
                <v-menu offset-y>
                    <template v-slot:activator="{ attr, on }">
                        <v-btn dark color="alert-color" v-on="on" v-bind="attr">
                            <v-icon class="me-1">mdi-export-variant</v-icon>
                            {{$t('exports.export')}}
                        </v-btn>
                    </template>

                    <v-list nav dense>
                        <v-list-item @click="getReport('pdf')">
                            <v-list-item-icon class="me-4">
                                <v-icon>mdi-printer</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>
                                {{$t('exports.export-as-pdf')}}
                            </v-list-item-title>
                        </v-list-item>
                        <!-- <v-list-item @click="getReport('excel')">
                            <v-list-item-icon class="me-4">
                                <v-icon>mdi-microsoft-excel</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>
                                {{$t('exports.export-as-excel')}}
                            </v-list-item-title>
                        </v-list-item> -->
                    </v-list>
                </v-menu>
            </v-col>
        </v-row>
        <v-row class="ma-0 pb-2" no-gutters>
            <v-col cols="auto" class="d-flex align-center px-2">
                <bee-date-picker
                    v-model="date"
                    context="materials_journal"
                    :action-name="actions.CREATE"
                    :label="$t('CashJournalPage.bond-date')"
                    :hide-details="true"
                    :disabled="loading || !$route.query.id" 
                    :rules="[rules.date]"
                    @blur="updateDocument(true)"
                ></bee-date-picker>
            </v-col>
            <v-col cols="3" class="d-flex align-center">
                <v-autocomplete
                    v-model="sourceWarehouse"
                    :items="targetWarehouse ? warehouses.filter(c => c.id !== targetWarehouse) : warehouses" 
                    item-text="name"
                    outlined
                    :disabled="isPosted || loading || Boolean((entries.length && transactionBond.source_warehouse_id)) || !$route.query.id"
                    :label="$t('headers.source-warehouse')"
                    hide-details
                    dense
                    item-value="id"
                    @change="updateDocument()"
                />
            </v-col>
            <v-col cols="3" class="d-flex align-center px-3">
                <v-autocomplete
                    v-model="targetWarehouse"
                    :items="sourceWarehouse ? warehouses.filter(c => c.id !== sourceWarehouse) : warehouses" 
                    item-text="name"
                    outlined
                    :disabled="isPosted || loading || Boolean((entries.length && transactionBond.target_warehouse_id)) || !$route.query.id"
                    :label="$t('headers.target-warehouse')"
                    hide-details
                    dense
                    item-value="id"
                    @change="updateDocument()"
                />
            </v-col>
            <v-col></v-col>
            <v-col cols="auto" xl="3" class="d-flex justify-end">
                <v-btn 
                    v-if="
                        useUnPostingPermission
                            ? (!isPosted || (isPosted && canUnPost))
                            : true
                    "
                    :color="!isPosted ? 'blueGray white--text' : 'deletingColor white--text'"
                    :disabled="(loading && !postingLoading) || !$route.query.id"
                    :loading="postingLoading"
                    height="60"
                    @click="!isPosted ? postedBound() : unPosted()"
                >   
                    {{ !isPosted ? $t('save') : $t('edit') }}
                </v-btn>

                <v-btn 
                    :color="isPosted ? 'postedColor white--text' : 'deletingColor white--text'"
                    height="60"
                    readonly
                    class="mx-2"
                    depressed
                >
                    <v-icon> mdi-email </v-icon>
                    {{ !isPosted ? $t('JournalsPage.non-posted') : $t('JournalsPage.posted') }}
                </v-btn>
            </v-col>
        </v-row>
        <bee-handy-smart-table
            v-model="tableInputs"
            ref="table"
            :headers="headers"
            :items="entries !== null ? entries : []"
            dense
            zebra
            fixed-header
            :show-add-row="!isPosted && bonds.length > 0"
            :items-per-page="-1"
            :reset-edit.sync="resetEdit"
			editable-rows
            pagination-on-scroll
            :height="$vuetify.breakpoint.height - 220"
            hide-inputs-details
            hide-shown-rows-text
            hide-no-data-area
            stay-in-input-field
            :context-menu-items="contextMenuItems"
            with-columns-divider
            :disable-context-menu="loading || isPosted"
            :scroll-to-row-expression="(item) => item.id === entryId || item.id === entries[entries.length - 1].id"
            :data-table-props="{ disableSort: true }"
            :disable-input-fields="loading"
            @keypress.enter="submitEntry()"
            @edit-cancelled="entryId = null"
			@context-menu-edit="setRowIndex"
			@context-menu-delete="({ item }) => deleteEntry(item.id)"
            @reached-last-input="submitEntry()"
            :loading="loading || submitLoading"
        >
            <template v-slot:input.source_warehouse_id="{ on, attr }">
                <v-autocomplete 
                    :items="tableInputs.target_warehouse_id ? warehouses.filter(c => c.id !== tableInputs.target_warehouse_id) : warehouses" 
                    item-text="name"
                    item-value="id"
                    v-on="on"
                    v-bind="attr"
                />
            </template>

            <template v-slot:input.source_material_id="{ on, attr }">
                <v-autocomplete 
                    :items="materials.filter(c => ((tableInputs.source_warehouse_id ? tableInputs.source_warehouse_id === c.warehouse_id : sourceWarehouse === c.warehouse_id )) && c.type === type.sub)"
                    item-text="name"
                    item-value="id"
                    v-on="on"
                    v-bind="attr"
                    @change="getMaterialLinked()"
                >
                    <template v-slot:item="data">
                        <v-list-item
                            v-on="data.on"
                            v-bind="data.attrs"
                            dense
                        >
                            <div class="d-flex flex-column py-1">
                                <span class="pe-3">
                                    {{ data.item.no + '-'+ data.item.name }}
                                </span>
                            </div>
                            <v-spacer></v-spacer>
                            <bee-material-amount-label :with-color="true" :value="data.item.balance" :show-zeros-values="true"></bee-material-amount-label>

                        </v-list-item>
                    </template>
                </v-autocomplete>
            </template>

            <template v-slot:input.target_warehouse_id="{ on, attr }">
                <v-autocomplete 
                    :items="warehouses.filter(c => c.id !== tableInputs.source_warehouse_id)"
                    item-text="name"
                    item-value="id"
                    v-on="on"   
                    v-bind="attr"
                />
            </template>

            <template v-slot:input.target_material_id="{ on, attr }">
                <v-autocomplete 
                    :items="itemLinkedWithMaterials"
                    item-text="name"
                    item-value="id"
                    v-on="on"
                    v-bind="attr"
                    :loading="loadingItems" 
                >
                    <template v-slot:item="data">
                        <v-list-item
                            v-on="data.on"
                            v-bind="data.attrs"
                            dense
                        >
                            <div class="d-flex flex-column py-1">
                                <span class="pe-3">
                                    {{ data.item.no + '-'+ data.item.name }}
                                </span>
                            </div>
                            <v-spacer></v-spacer>
                            <bee-material-amount-label :with-color="true" :value="materials.find(v => v.id === data.item.id)?.balance" :show-zeros-values="true"></bee-material-amount-label>

                        </v-list-item>
                    </template>
                </v-autocomplete>
            </template>

            <template v-slot:input.unit="{ on, attr }">
                <v-autocomplete 
                    :items="unitSizes"
                    item-text="name"
                    item-value="id"
                    v-on="on"
                    v-bind="attr"
                />
            </template>

            <template v-slot:input.date="{ on, attr }">
                <bee-date-input
                    label=" "
                    fit-inputs
                    dense
                    input-format-order="DD-MM-YYYY"
                    v-on="on"
                    v-bind="attr"
                ></bee-date-input>
            </template>

            <template v-slot:item.hint="{ item, index }">
                <div class="text-center">
                    <v-menu offset-y>
                        <template v-slot:activator="{ on, attr }">
                            <v-btn
                                small
                                icon
                                v-bind="attr"
                                v-on="on"
                                width="32"
                            >
                                <v-icon>
                                    mdi-dots-vertical
                                </v-icon>
                            </v-btn>
                        </template>
                        <v-list dense>
                            <v-list-item @click="setRowIndex({item, index }, true)">
                                <v-list-item-content class="pa-0">
                                    {{ $t('buttons.edit') }}
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item @click="deleteEntry(item.id)">
                                <v-list-item-content class="pa-0">
                                    {{ $t('buttons.delete') }}
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>
            </template>
        </bee-handy-smart-table>
    </div>
</template>

<!--  -->
<script>
import { mapState } from "vuex";
import rules from "../../../validation";
import actions from "../../../permissions/actions-names.js";
import moment from "moment";
import EventBus from "@/event-bus";
import { useUnPostingPermission } from '@/configs/global'
import { type } from '@/helpers/enums';
import ls from "@/settings/localStorageExtension";
export default {
    watch: {
        'tableInputs.source_warehouse_id'(val) {
            if(val) {
                this.tableInputs.source_material_id = null;
                this.tableInputs.target_material_id = null;
            }
        },
        'tableInputs.target_warehouse_id'() {
            this.tableInputs.target_material_id = null;
            this.getMaterialLinked()
        }
    },
    data() {
        return {
            type,

            loading: false,
            loadingItems: false,

            date: null,
            dialog: false,
            rules,
            actions,
            entries: [],
            entryId: null,
            tableInputs: {
                date: moment().format('YYYY-MM-DD')
            },
            rowEditIndex: null,
            isEditItem: null,
            resetEdit: false,
            boundNo: null,

            deleteDialog: false,
            isPosted: null,
            deleteEntryId: null,
            itemLinkedWithMaterials: [],
            submitLoading: false,
            sourceWarehouse: null,
            targetWarehouse: null,
            bonds: [],
            materialsLoading: false,
            useUnPostingPermission,
            createBondForm: {
                date: null,
                source_warehouse_id: null,
                target_warehouse_id: null
            },
            transactionBondId: null,
            targetMaterial: null,
            postingLoading: false,
            isMultipleWarehouses: false,
            transactionBond: {}
        }
    },
    computed: {
        ...mapState({
            warehouses: state => state.warehouses.warehouses,
            materials: state => state.materials.materials,
            transactionBonds: state => state.transactionBonds.transactionBonds,
            unitSizes: state => state.unitSizes.unit_sizes,
            canUnPost: state => state.permissions.selfPermissions.canUnPost,
            currentFinancialFile: state => state.financialFiles.current_financial_file,
        }),
        ...mapState("configs" , ["configs"]),
        contextMenuItems() {
			return [
				{
					title: this.$t('buttons.edit'),
					event: 'edit',
				},
				{
					title: this.$t('buttons.delete'),
					event: 'delete',
				},
			]
		},
        headers() {
            const headers = [
                !this.transactionBond.source_warehouse_id 
                    ? {
                        text: this.$t('headers.source-warehouse'),
                        name: 'source_warehouse_id',
                        value: 'source_warehouse_id',
                        width: 180,
                        inputRules: [rules.rules.required],
                        setValueExpr: val => this.warehouses.find(c => c.id === val)?.name,
                        columnClass: 'px-2'
                    } 
                    : null,
                {
                    text: this.$t('TransferDocument.source-warehouse-material'),
                    name: 'source_material_id',
                    value: 'source_material_id',
                    inputRules: [rules.rules.required],
                    setValueExpr: val => this.materials.find(c => c.id === val)?.name,
                    columnClass: 'px-2'
                },
                !this.transactionBond.target_warehouse_id 
                    ? {
                        text: this.$t('headers.target-warehouse'),
                        name: 'target_warehouse_id',
                        value: 'target_warehouse_id',
                        width: 180,
                        inputRules: [rules.rules.required],
                        setValueExpr: val => this.warehouses.find(c => c.id === val)?.name,
                        columnClass: 'px-2'
                    } 
                    : null,
                {
                    text: this.$t('TransferDocument.target-warehouse-material'),
                    name: 'target_material_id',
                    value: 'target_material_id',
                    width: 240,
                    inputRules: [rules.rules.required],
                    setValueExpr: val => this.materials.find(c => c.id === val)?.name,
                    columnClass: 'px-2'
                },
                {
                    text: this.$t('headers.quantity'),
                    name: 'quantity',
                    value: 'quantity.quantity',
                    type: 'number',
                    width: 100,
                    inputRules: [rules.rules.required],
                },
                {
                    text: this.$t('manufacturingBond.headers.unit'),
                    name: 'unit',
                    value: 'quantity.unit_size_id',
                    width: 120,
                    inputRules: [rules.rules.required],
                    setValueExpr: (val) => this.unitSizes.find(c => c.id === val)?.name,
                    columnClass: 'px-2'
                },
                {
                    text: this.$t('headers.count'),
                    name: 'count',
                    value: 'count',
                    type: 'number',
                    width: 120,
                    columnClass: 'px-2'
                },
                {
                    text: this.$t('headers.notes'),
                    name: 'notes',
                    value: 'notes',
                    columnClass: 'px-2'
                },
                {
                    text: this.$t('headers.date'),
                    name: 'date',
                    value: 'date',
                    inputRules: [rules.rules.required],
                    columnClass: 'px-2',
                    width: 100
                },
                !this.isPosted
                    ? {
                        text: '',
                        name: 'hint',
                        value: 'hint',
                        divider: false,
                        width: 40,
                        class: 'px-0',
                        cellClass: 'px-0',
                        noInput: true,
                        noNotAvailableText: true
                    }
                    : null
            ]
            // if(!this.isPosted) {
			// 	headers.push()
			// }
            return headers.filter(Boolean)
        },

        boundNoList() {
            return this.bonds.map(c => c.transaction_no);
        },
    },

    methods: {
        moment,
        addDocument() {
            if(this.$refs.addForm.validate()) {
                this.loading = true
                this.$store.dispatch('transactionBonds/create', { 
                    date: this.createBondForm.date, 
                    source_warehouse_id: this.createBondForm.source_warehouse_id, 
                    target_warehouse_id: this.createBondForm.target_warehouse_id 
                })
                .then(({ data }) => {
                    this.boundNo = data.transaction_no
                    this.entries = []
                    this.$router.push({
                        name: 'transfer-document',
                        query: { id: data.id }
                    });
                    this.fetchAllBounds();
                }).finally(() => {
                    this.loading = false
                    this.dialog = false
                })
            }
        },
        updateDocument(isDateUpdate = false) {
            if (!this.transactionBond.source_warehouse_id && !this.transactionBond.target_warehouse_id && !isDateUpdate) {
                this.tableInputs.source_warehouse_id = this.sourceWarehouse;
                this.tableInputs.target_warehouse_id = this.targetWarehouse;
                return;
            }
            this.loading = true;
            this.$store.dispatch('transactionBonds/update', {
                transactionBondId: this.transactionBondId,
                date: this.date,
                source_warehouse_id: this.transactionBond.source_warehouse_id ? this.sourceWarehouse : null,
                target_warehouse_id: this.transactionBond.target_warehouse_id ? this.targetWarehouse : null
            }).then(() => {
                EventBus.$emit('notification', this.$t('update-bond-notification'))
            }).finally(() => {
                this.fetchJournalByNo();
                this.loading = false;
            })
        },
        submitEntry() {
            if (!this.$refs.table.validate()) return;

            this.submitLoading = true
			// console.log(this.transactionBond.source_warehouse_id, this.targetWarehouse, this.tableInputs.target_warehouse_Id)
            const actionName = this.entryId ? 'updateEntry' : 'createEntry'
            this.$store.dispatch(`transactionBonds/${actionName}`, { 
                entryId: this.entryId ? this.entryId : null,
                source_warehouse_id: this.transactionBond.source_warehouse_id ? this.sourceWarehouse : this.tableInputs.source_warehouse_id ,
                target_warehouse_id: this.transactionBond.source_warehouse_id ? this.targetWarehouse : this.tableInputs.target_warehouse_id, 
                source_material_id: this.tableInputs.source_material_id, 
                target_material_id :this.tableInputs.target_material_id, 
                transaction_bond_id : +this.$route.query.id,  
                quantity: {
                    quantity: Number(this.tableInputs.quantity),
                    unit_size_id: this.tableInputs.unit
                },
                count: this.tableInputs.count,
                notes: this.tableInputs.notes, 
                date: this.tableInputs.date
            }).then(() => {
                this.$refs.table.resetInputsFocus();
                this.getAllEntries().finally(() => {
                    this.submitLoading = false
                    this.$refs.table.resetInputs({ 
                        date: this.date, 
                        source_warehouse_id: this.sourceWarehouse, 
                        target_warehouse_id: this.targetWarehouse 
                    })
                })
            }).catch(() => {
                this.submitLoading = false;
            }).finally(() => {
                this.$refs.table.resetEdit()
                this.isEditItem = false
                this.entryId = null
            })
        },

        getAllEntries() {
            return this.$store.dispatch('transactionBonds/fetchEntries', { transactionBondId: this.$route.query.id }).then((data) => {
                this.entries = data.data.map((c) => ({ ...c, unitSizes: c.quantity.unit_size_id}))
            })
        },

        setRowIndex(rowData, needToOpenEdit = false) {
			if(needToOpenEdit) {
				this.$refs.table.activeEditForRow(rowData.index);
			}
			this.rowEditIndex = rowData.index;
			this.entryId = rowData.item.id;
			this.$nextTick(() => {
				this.$refs.table.resetInputsFocus();
                this.getMaterialLinked();
			})
		},

        deleteEntry(id) {
            this.loading = true
            this.$store.dispatch('transactionBonds/deleteEntry', {  
                transactionBondId: this.$route.query.id,
                entryId: id
            }).then(() => {
                this.getAllEntries()
            }).finally(() => {
                this.loading = false
                this.entryId = null
            })
        },

        fetchJournalByNo() {
            const journalId = this.bonds.find(c => c.transaction_no === this.boundNo)?.id;
            if (journalId && +this.$route.query.id !== journalId) {
                this.$router.push({
                    name: 'transfer-document',
                    query: { id: journalId }
                })
            }
            this.entries = [];
            
            this.loading = true
            this.$store.dispatch('transactionBonds/fetchJournalByNo', {
                transactionBondNo: this.boundNo
            }).then((data) => {
                this.transactionBondId = data.data.id;
                this.entries = data.data.entries
                this.isPosted = data.data.is_posted 
                // temporary need to fix and be replaced with a data from backend
                this.sourceWarehouse = data.data.source_warehouse_id || this.entries[this.entries.length - 1]?.source_warehouse_id || this.configs.warehouse.id;
                this.targetWarehouse = data.data.target_warehouse_id || this.entries[this.entries.length - 1]?.target_warehouse_id;
                this.date = data.data.date;
                this.transactionBond = data.data;
                // this.$nextTick(() => {

                //     this.tableInputs.source_material_id = null;
                //     this.tableInputs.target_material_id = null;
                // })
                this.$nextTick(() => {
                    this.$refs.table.resetInputs({ date: this.date, source_warehouse_id: this.sourceWarehouse, target_warehouse_id: this.targetWarehouse, source_material_id: null, target_material_id: null })
                })
            }).finally(() => {
                this.loading = false
            })
        },
        
        fetchAllBounds(isFirst = false) {
            this.$store.dispatch('transactionBonds/fetchMaterialFlow', { 
                fromDate: moment(this.configs.financial_file.start_date).format('YYYY-MM-DD'),
                toDate: moment(new Date().toISOString().substr(0, 10)).format('YYYY-MM-DD')
            }).then((data) => {
                this.bonds = data;

                if (data.length) {
                    if (isFirst && !this.$route.query.id) {
                        this.boundNo = this.bonds[this.bonds.length - 1].transaction_no;
                        this.$router.push({
                            name: 'transfer-document',
                            query: { id: this.bonds[this.bonds.length - 1].id }
                        })
                    } else if(this.$route.query.id) {
                        this.boundNo = this.bonds.find(c => c.id === +this.$route.query.id)?.transaction_no
                    }
                    this.fetchJournalByNo()
                } else {
                    this.boundNo = null;
                }
            })
        },
        confirmDeleteDocument() {
            this.loading = true
            this.$store.dispatch('transactionBonds/delete', {
                transactionBondId: this.$route.query.id
            }).then(() => {
                this.entries = [];
                this.$router.replace({ name: 'transfer-document' });
                this.fetchAllBounds(true);
            }).finally(() => {
                this.loading = false
                this.deleteDialog = false
            })
        },

        postedBound() {
            this.loading = true
            this.postingLoading = true;
            this.$store.dispatch('transactionBonds/posted', { transactionBondId: this.$route.query.id }).then(() => {
                this.isPosted = true
                this.fetchMaterials();
            }).finally(() => {
                this.loading = false
                this.postingLoading = false;
            })
        },

        unPosted() {
            this.postingLoading = true;
            this.loading = true
            this.$store.dispatch('transactionBonds/unPosted', { transactionBondId: this.$route.query.id }).then(() => {
                this.isPosted = false
                this.fetchMaterials()
            }).finally(() => {
                this.loading = false
                this.postingLoading = false;
            })
        },
        nextJournal() {
            const indexOfCurrentInvoice = this.boundNoList.indexOf(this.boundNo);
            if (indexOfCurrentInvoice !== this.boundNoList.length - 1) {
                this.boundNo = this.boundNoList[this.boundNoList.indexOf(this.boundNo) + 1]
                this.fetchJournalByNo()
            }
		},
		prevJournal() {
            const indexOfCurrentInvoice = this.boundNoList.indexOf(this.boundNo);
            if (![-1, 0].includes(indexOfCurrentInvoice)) {
                this.boundNo = this.boundNoList[indexOfCurrentInvoice - 1]
                this.fetchJournalByNo()
            }
		},
        fetchMaterials(isUpdate = true) {
            this.materialsLoading = true;
            return this.$store.dispatch('materials/fetchAll').then(() => {
                this.materialsLoading = false;
               if(isUpdate) {
                    EventBus.$emit('notification', this.$t('update-materials-notifications'))
               }
            });
        },
        getMaterialLinked() {
            this.tableInputs.target_material_id = null;
            if (this.tableInputs.source_material_id && ((this.transactionBond.source_warehouse_id) || (!this.transactionBond.source_warehouse_id && this.tableInputs.target_warehouse_id))) {
                this.loadingItems = true
                this.$store.dispatch('warehouses/fetchMaterialLinkedWithMaterial', { 
                    materialId: this.tableInputs.source_material_id
                }).then(({ data }) => {
                    this.itemLinkedWithMaterials = data.filter(c =>
                        (this.tableInputs.target_warehouse_id ? c.warehouse_id === this.tableInputs.target_warehouse_id : c.warehouse_id === this.targetWarehouse) &&
                        c.type === type.sub
                    );
                    this.tableInputs.target_material_id = this.itemLinkedWithMaterials[0].id;
                }).finally(() => {
                    this.loadingItems = false
                })
            }
        },
        getReport() {
            this.$store.dispatch('reports/transactionBond', {
                financialFileId: this.currentFinancialFile.id,
                userId: ls.getLocalUser().id,
                transactionBondId: this.$route.query.id,
                type: 'pdf',
            })
        }
    },

    created() {
        Promise.all([
            !this.warehouses.length ? this.$store.dispatch('warehouses/fetchAll') : null,
            !this.materials.length ? this.fetchMaterials(false) : null,
            !this.unitSizes.length ? this.$store.dispatch("unitSizes/fetchAll") : null,
            this.fetchAllBounds(true)
        ]).finally(() => {
            this.$refs.table.resetInputs({ date: new Date().toISOString().slice(0, 10), source_warehouse_id: this.sourceWarehouse, target_warehouse_id: this.targetWarehouse })

        })
    }
}
</script>
